// extracted by mini-css-extract-plugin
export default {"aboutWrapper":"AboutWrapper_aboutWrapper__EGXZu"};